<template>
  <ts-loading-banner :loading="waiting">
    <div class="tw-space-y-2">
      <div class="row">
        <div class="col-md-12 tw-space-y-1">
          <label class="required">{{ $t("branchProfile.companyName") }}</label>
          <select
            v-model="model.company_id"
            class="form-select"
            :class="{
              'is-invalid': errors.has('company_id'),
            }"
          >
            <option value="" selected disabled style="display: none">
              {{ $t("branchProfile.companyName") }}
            </option>
            <option
              v-for="(com, index) in companies"
              :key="index"
              :value="com.company_id"
            >
              {{ com.company_name_en }}
            </option>
          </select>
          <div class="invalid-feedback" v-if="errors.has('company_id')">
            {{ errors.first("company_id") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6 tw-space-y-1">
          <label class="required">{{ $t("branchProfile.nameEn") }}</label>
          <input
            v-model="model.branch_name_en"
            type="text"
            class="form-control"
            :class="{
              'is-invalid': errors.has('branch_name_en'),
            }"
            :placeholder="$t('branchProfile.nameEn')"
          />
          <div class="invalid-feedback" v-if="errors.has('branch_name_en')">
            {{ errors.first("branch_name_en") }}
          </div>
        </div>
        <div class="col-6 tw-space-y-1">
          <label>{{ $t("branchProfile.nameKh") }}</label>
          <input
            v-model="model.branch_name_kh"
            type="text"
            class="form-control"
            :class="{
              'is-invalid': errors.has('branch_name_kh'),
            }"
            :placeholder="$t('branchProfile.nameKh')"
          />
          <div class="invalid-feedback" v-if="errors.has('branch_name_kh')">
            {{ errors.first("branch_name_kh") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6 tw-space-y-1">
          <label class="required">{{ $t("branchProfile.phone") }}</label>
          <input
            v-model="model.phone"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('phone') }"
            :placeholder="$t('branchProfile.phone')"
          />
          <div class="invalid-feedback" v-if="errors.has('phone')">
            {{ errors.first("phone") }}
          </div>
        </div>
        <div class="col-6 tw-space-y-1">
          <label class="required">{{ $t("branchProfile.prefix") }}</label>
          <input
            v-model="model.prefix_code"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('prefix_code') }"
            :placeholder="$t('branchProfile.prefix')"
          />
          <div class="invalid-feedback" v-if="errors.has('prefix_code')">
            {{ errors.first("prefix_code") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6 tw-space-y-1">
          <label>{{ $t("branchProfile.facebookPage") }}</label>
          <input
            v-model="model.facebook_page"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('facebook_page') }"
            :placeholder="$t('branchProfile.facebookPage')"
          />
          <div class="invalid-feedback" v-if="errors.has('facebook_page')">
            {{ errors.first("facebook_page") }}
          </div>
        </div>
        <div class="col-6 tw-space-y-1">
          <label>{{ $t("branchProfile.website") }}</label>
          <input
            v-model="model.branch_website"
            type="email"
            class="form-control"
            :class="{ 'is-invalid': errors.has('branch_website') }"
            :placeholder="$t('branchProfile.website')"
          />
          <div class="invalid-feedback" v-if="errors.has('branch_website')">
            {{ errors.first("branch_website") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6 tw-space-y-1">
          <label>{{ $t("branchProfile.email") }}</label>
          <input
            v-model="model.branch_email"
            type="email"
            class="form-control"
            :class="{ 'is-invalid': errors.has('branch_email') }"
            :placeholder="$t('branchProfile.email')"
          />
          <div class="invalid-feedback" v-if="errors.has('branch_email')">
            {{ errors.first("branch_email") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label>{{ $t("branchProfile.address") }}</label>
          <textarea
            v-model="model.branch_address"
            rows="3"
            class="form-control"
            :placeholder="$t('branchProfile.address')"
            :class="{ 'is-invalid': errors.has('branch_address') }"
          ></textarea>
          <div class="invalid-feedback" v-if="errors.has('branch_address')">
            {{ errors.first("branch_address") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 tw-flex tw-justify-end tw-space-x-3">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t("cancel") }}
          </ts-button>
          <ts-button v-if="!isUpdate" color="primary" @click.prevent="onSave">{{
            $t("save")
          }}</ts-button>
          <ts-button
            v-if="isUpdate"
            color="primary"
            @click.prevent="onUpdate"
            >{{ $t("update") }}</ts-button
          >
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { isEmpty } from "lodash";
import { mapState } from "vuex";
import { Errors } from "form-backend-validation";

export default {
  name: "branchForm",
  data() {
    return {
      waiting: false,
      errors: new Errors(),
      showBrowseFileBotton: false,
      companies: [],
      model: {
        branch_id: null,
        company_id: "",
        branch_name_kh: null,
        prefix_code: null,
        branch_name_en: null,
        phone: null,
        branch_website: null,
        facebook_page: null,
        branch_email: null,
        branch_address: null,
      },
    };
  },
  computed: {
    ...mapState("corporate/branchProfile", ["edit_data"]),
    isUpdate() {
      return !isEmpty(this.edit_data);
    },
  },
  async created() {
    await this.fetchFormViewModel();
    this.setEditData();
  },
  methods: {
    async onSave() {
      this.waiting = true;
      this.$store
        .dispatch("corporate/branchProfile/store", this.model)
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("fetchData");
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    async onUpdate() {
      this.waiting = true;
      this.$store
        .dispatch("corporate/branchProfile/update", {
          id: this.model.branch_id,
          data: this.model,
        })
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    fetchFormViewModel() {
      this.waiting = true;
      this.$store
        .dispatch("corporate/branchProfile/getFormViewData")
        .then((response) => {
          this.companies = response.data.company;
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.branch_id = this.edit_data.branch_id;
        this.model.company_id = this.edit_data.company_id;
        this.model.branch_name_kh = this.edit_data.branch_name_kh;
        this.model.prefix_code = this.edit_data.prefix_code;
        this.model.phone = this.edit_data.phone;
        this.model.branch_name_en = this.edit_data.branch_name_en;
        this.model.branch_address = this.edit_data.branch_address;
        this.model.branch_email = this.edit_data.branch_email;
        this.model.facebook_page = this.edit_data.facebook_page;
        this.model.branch_website = this.edit_data.branch_website;
      }
    },
  },
};
</script>
